import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-widget-dashboard-dialog',
  templateUrl: './widget-dashboard-dialog.component.html',
  styleUrls: ['./widget-dashboard-dialog.component.scss'],
  standalone: false,
})
export class WidgetDashboardDialogComponent {
  widgetData = inject(MAT_DIALOG_DATA);
}
